import script from "./DomainDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainDetailDrawer.vue?vue&type=script&setup=true&lang=js"

import "./DomainDetailDrawer.vue?vue&type=style&index=0&id=71a1fdb7&lang=scss"

const __exports__ = script;

export default __exports__